import { Card } from '@payaca/ambrosia';
import { FC, ReactNode } from 'react';

export type TProps = {
  children: ReactNode;
};

const LightboxMessage: FC<TProps> = (props) => {
  const { children } = props;

  return (
    <Card className="typography:prose bg-white">
      <Card.Body className="flex flex-col items-center justify-center gap-4">
        {children}
      </Card.Body>
    </Card>
  );
};

export default LightboxMessage;
